import { ToolboxProvider } from "./Toolbox/ToolboxProvider"
import { PluginProvider } from "./PluginProvider"
import { useRoutingParameter } from "panels/routing/useRoutingId"
import { useEffect } from "react"
import { useAppDispatch } from "integrations/redux/hooks"
import { setGlobalNotificationContext } from "user/profile/slice"
import { GlobalNotificationStatus } from "@nova/component-global-notification"
import { VideoProvider } from "./Video/ui/VideoProvider"
import { UserLocationShareProvider } from "./UserLocationShare/ui/UserLocationShareProvider"

/**
 * purely responsible for hiding the plugin provider whenever the run-level does not permit plugins to be visible
 */
export function PluginPanelsContainer() {
    const dispatch = useAppDispatch()
    const paymentSuccess = useRoutingParameter("payment_success")

    //used to catch redirects from Stripe Checkout and display the payment success notification
    useEffect(() => {
        if (paymentSuccess) {
            dispatch(
                setGlobalNotificationContext({
                    message: "Purchase Confirmed! Your upgrade is now active.",
                    status: GlobalNotificationStatus.success,
                    timeoutInMs: 6000,
                })
            )
            const url = new URL(window.location.href)
            url.searchParams.delete("payment_success")
            window.history.replaceState(null, "", url.toString())
        }
    }, [paymentSuccess, dispatch])

    return (
        <>
            <PluginProvider />
            <ToolboxProvider />
            <VideoProvider />
            <UserLocationShareProvider />
        </>
    )
}
